import React from 'react';

// KizCodeIcon 图标组件
const KizCodeIcon = ({ width = 59, height = 24 }) => (
    <img 
        src="https://oss.essaone.com/fe0e0370-e5c2-4843-a84f-7fe4bb96780c.jpg"
        alt="fulfillment" 
        style={{ width, height,}}
    />
);

export default KizCodeIcon;